var thresholdbar = document.querySelectorAll('[data-id-thresholdbar]');
var tresholdbarPreText = document.querySelectorAll('[data-id-tresholdbarPreText]');
var tresholdbarPostText = document.querySelectorAll('[data-id-tresholdbarPostText]');
var tresholdbarAmount = document.querySelectorAll('[data-id-tresholdbarAmount]');
var thresholdbarBar = document.querySelectorAll('[data-id-thresholdbarBar]');
var thresholdbarInner = document.querySelectorAll('[data-id-thresholdbarInner]');

function thresholdInit() {
    thresholdBarWidth();
}

function thresholdBarWidth() {
    var cartAmount = thresholdbarBar[0].dataset.tresholdbarCartAmount;
    var percentageAmount = Math.round(cartAmount / 5000 * 100);

    var displayAmount = 0;

    if (percentageAmount > 95 && percentageAmount < 99.9) {
        displayAmount = '95%'
    } else if (percentageAmount > 99.9)  {
        displayAmount = '100%'
    } else {
        displayAmount = percentageAmount + '%'
    }
    
    thresholdbarInner.forEach(function(el) {
        el.style.width = displayAmount;
    })
}

// Called in theme.js
function updateThresholdAmount(cart) {
    classContoller(cart.total_price);
    
    thresholdbarBar.forEach(function(el) {
        el.setAttribute('data-tresholdbar-cart-amount', cart.total_price);
    })

    var amountDisplay = 5000 - cart.total_price;

    tresholdbarAmount.forEach(function(el) {
        el.innerHTML = theme.Currency.formatMoney(amountDisplay, theme.moneyFormat)
    })

    thresholdBarWidth();
}

function classContoller(price) {
    if (price >= 5000) {

        tresholdbarPreText.forEach(function(el) {
          
            if (el.classList.contains('sq-thresholdbar__pre-text--active')) {
              
                el.classList.remove('sq-thresholdbar__pre-text--active');
            }
        })

        tresholdbarPostText.forEach(function(el) {
      
            if (!el.classList.contains('sq-thresholdbar__post-text--active')) {
               
                el.classList.add('sq-thresholdbar__post-text--active')
            }
        })
    } else {
        tresholdbarPreText.forEach(function(el) {
            if (!el.classList.contains('sq-thresholdbar__pre-text--active')) {
                el.classList.add('sq-thresholdbar__pre-text--active');
            }
        })

        tresholdbarPostText.forEach(function(el) {
            if (el.classList.contains('sq-thresholdbar__post-text--active')) {
                el.classList.remove('sq-thresholdbar__post-text--active')
            }
        })
    }
}

if (thresholdbar.length) {
    thresholdInit();  
}
